import { commonMediaKeys, v700diyFnFactoryKeys, type KeysConfig } from './common'

export const v700diy98Keys: KeysConfig = {
  factoryKeys: {
    win: { ...v700diyFnFactoryKeys },
    mac: { ...v700diyFnFactoryKeys },
  },
  mediaKeys: [...commonMediaKeys],
}
